import { render, staticRenderFns } from "./MobileFilters.vue?vue&type=template&id=5ba5988d&scoped=true"
import script from "./MobileFilters.vue?vue&type=script&lang=js"
export * from "./MobileFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba5988d",
  null
  
)

export default component.exports